import { render, staticRenderFns } from "./WPPalettePicker.vue?vue&type=template&id=f208a9aa"
import script from "./WPPalettePicker.vue?vue&type=script&lang=ts"
export * from "./WPPalettePicker.vue?vue&type=script&lang=ts"
import style0 from "./WPPalettePicker.vue?vue&type=style&index=0&id=f208a9aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports